import { Injectable } from '@angular/core';
import { CONFIG } from '@app/core/constants/app-config-restriction-keys';
import { SOCIAL_URL } from '@app/core/constants/app-constant';
import { StorageConstants } from '@app/core/constants/storage-constants';
import { MobileConfiguration } from '@app/shared/interfaces/intune.interface';
import { AuthProviders, AuthProvidersTypes } from '@app/shared/models/AuthProviders';
import { DomainInfo } from '@app/shared/models/DomainInfo';
import { LocationData } from '@app/shared/models/LocationData';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { ManagedConfigurations } from '@capawesome/capacitor-managed-configurations';
import { IntuneNative } from 'capacitor-plugins/capacitor-plugin-intune/src';
import { BehaviorSubject } from 'rxjs';
import { DomainService } from '../domain/domain.service';
import { LoadingService } from '../loading/loading.service';
import { LoginAccountService } from '../login-account/login-account.service';
import { SharedService } from '../shared/shared.service';
import { StorageService } from '../storage/storage.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class IntuneService {
  portalAppAvail = false;
  mdmProfile!: MobileConfiguration;
  mobileConfigurationSubject$: BehaviorSubject<MobileConfiguration> = new BehaviorSubject(null);
  appUrlOpenListner: any;

  constructor(
    private storageService: StorageService,
    private storageConstants: StorageConstants,
    private domainSvc: DomainService,
    private sharedSvc: SharedService,
    private appAvailability: AppAvailability,
    private inAppBrowser: InAppBrowser,
    private loginAccountService: LoginAccountService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) {}

  async checkPortalAppAvail() {
    try {
      const result = await this.appAvailability.check('companyportal://');
      this.portalAppAvail = result;
    } catch (error) {
      console.log('error', error);
      this.portalAppAvail = false;
    }
    return;
  }

  async setLatestMdmProfile() {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      await this.checkPortalAppAvail();
    }
    this.mdmProfile = await this.storageService.getJson(this.storageConstants.MDM_PROFILE);
    this.handleManageConfiguration();
    return;
  }

  updateMdmProfileInStorage(mdmProfile: MobileConfiguration, domainDetail?: DomainInfo) {
    this.mdmProfile = mdmProfile;
    this.storageService.setJson(this.storageConstants.MDM_PROFILE, mdmProfile);
    this.handleManageConfiguration(domainDetail);
    return;
  }

  handleManageConfiguration(domainDetail?: DomainInfo) {
    const domainData = domainDetail || this.sharedSvc.getCustomerDetails;
    let mobileConfig = domainData?.customizationsText?.MobileConfiguration;
    let newMdmProfile = this.mdmProfile ? JSON.parse(JSON.stringify(this.mdmProfile)) : null;
    if ((this.portalAppAvail || Capacitor.getPlatform() === 'android') && newMdmProfile) {
      if (Capacitor.getPlatform() === 'android') {
        if (newMdmProfile?.CloudStorage === null || newMdmProfile?.CloudStorage === undefined) {
          newMdmProfile.CloudStorage = mobileConfig?.CloudStorageToggle !== false;
        }
        if (newMdmProfile?.Domain === null || newMdmProfile?.Domain === undefined) {
          newMdmProfile.Domain = mobileConfig?.Domain;
        }
        if (newMdmProfile?.EmailOption === null || newMdmProfile?.EmailOption === undefined) {
          newMdmProfile.EmailOption = mobileConfig?.EmailOption;
        }
        if (newMdmProfile?.FileOption === null || newMdmProfile?.FileOption === undefined) {
          newMdmProfile.FileOption = mobileConfig?.FileOption;
        }
        if (
          newMdmProfile?.LockLocationChange === null ||
          newMdmProfile?.LockLocationChange === undefined
        ) {
          newMdmProfile.LockLocationChange = mobileConfig?.LockLocationChange;
        }
        if (newMdmProfile?.PictureOption === null || newMdmProfile?.PictureOption === undefined) {
          newMdmProfile.PictureOption = mobileConfig?.PictureOption;
        }
        if (newMdmProfile?.QRScanning === null || newMdmProfile?.QRScanning === undefined) {
          newMdmProfile.QRScanning = mobileConfig?.QRScanning;
        }
        if (newMdmProfile.hasOwnProperty('CloudStorage') && newMdmProfile?.CloudStorage !== false) {
          newMdmProfile.CloudStorage = mobileConfig?.CloudStorage;
        }
      }
      mobileConfig = {
        ...mobileConfig,
        ...newMdmProfile,
      };

      const cloudStorageAvail = newMdmProfile.hasOwnProperty('CloudStorage');
      const cloudStorageToggleAvail = mobileConfig.hasOwnProperty('CloudStorageToggle');
      if (cloudStorageAvail && cloudStorageToggleAvail) {
        delete mobileConfig.CloudStorageToggle;
      }
    }
    // if (mobileConfig) {
    console.log('final intune config data =====>', mobileConfig);
    this.mobileConfigurationSubject$.next(mobileConfig);
    // }
  }

  removeMdmProfile() {
    this.storageService.remove(this.storageConstants.MDM_PROFILE);
    this.setLatestMdmProfile();
  }

  handleConfigListener() {
    IntuneNative.addListener('appConfigChange', async () => {
      console.log('appConfigChange listener call ===>');

      // const user = await IntuneNative.enrolledAccount();
      // if (user.upn) {
      //   const mdmReceived = await IntuneNative.appConfig(user);
      //   const intuneConfig = this.setIntuneConfigData(mdmReceived["fullData"][0]);
      //   console.log("Config after listener",intuneConfig)
      //   if (intuneConfig) {
      //     await this.updateMdmProfileInStorage(intuneConfig);
      //     if(intuneConfig?.Domain){
      //       this.handleDomainDetail(intuneConfig);
      //     }
      //   }
      // }
    });
  }

  // async getToken(user) {
  //   if (user.upn) {
  //     try {
  //       const tokenInfo = await IntuneNative.acquireTokenSilent({
  //         scopes: ['user.read', 'offline_access'],
  //         upn: user.upn,
  //       });
  //       // this.tokenInfo = tokenInfo;
  //       console.log('Got token info', tokenInfo);
  //     } catch {
  //       console.error(
  //         'Unable to silently acquire token, getting interactive'
  //       );
  //       const tokenInfo = await IntuneNative.acquireToken({
  //         scopes: ['https://graph.microsoft.com/.default'],
  //       });
  //       console.log('Got token info', tokenInfo);
  //       // this.tokenInfo = tokenInfo;
  //     }
  //   }
  // }

  async loadIntuneConfig() {
    let intuneConfig!: MobileConfiguration;
    try {
      if (Capacitor.getPlatform() === 'ios' && !this.portalAppAvail) {
        return;
      }

      if (Capacitor.getPlatform() === 'ios') {
        const user = await IntuneNative.enrolledAccount();
        if (user.upn) {
          // await this.getToken(user);
          const mdmReceived = await IntuneNative.appConfig(user);
          intuneConfig = this.setIntuneConfigData(mdmReceived['fullData'][0]);
          this.handleConfigListener();
        } else {
          await IntuneNative.loginAndEnrollAccount();
          const user = await IntuneNative.enrolledAccount();
          if (user.upn) {
            const mdmReceived = await IntuneNative.appConfig(user);
            intuneConfig = this.setIntuneConfigData(mdmReceived['fullData'][0]);
            this.handleConfigListener();
          }
        }
      } else {
        intuneConfig = {
          CloudStorage: await this.getBooleanKeyValue(CONFIG.CLOUD_STORAGE),
          Domain: await this.getStringKeyValue(CONFIG.DOMAIN),
          EmailOption: await this.getBooleanKeyValue(CONFIG.EMAIL_OPTION),
          FileOption: await this.getBooleanKeyValue(CONFIG.FILE_OPTION),
          LockLocationChange: await this.getBooleanKeyValue(CONFIG.LOCK_LOCATION_CHANGE),
          PictureOption: await this.getBooleanKeyValue(CONFIG.PICTURE_OPTION),
          QRScanning: await this.getBooleanKeyValue(CONFIG.QR_SCANNING),
        };
      }
    } catch (error) {
      console.log('error ======>', error);
    }
    if (intuneConfig) {
      let domainDetail: DomainInfo;
      if (intuneConfig?.Domain) {
        domainDetail = await this.handleDomainDetail(intuneConfig);
      }
      this.updateMdmProfileInStorage(intuneConfig, domainDetail);
      if (intuneConfig?.Domain) {
        this.setDefaultLocation(domainDetail);
      }
    }
  }

  async setDefaultLocation(data: DomainInfo) {
    const mobileConfig = this.mobileConfigurationSubject$.value;
    if (data?.locations.length) {
      const domainDetail = await this.sharedSvc.getDomainInfo();
      const availIntuneLoc = data.locations.some((loc) => loc?._id === domainDetail?.locationId);
      if (!availIntuneLoc) {
        const setDefaultLocation = data.locations.find(
          (loc) => loc._id === mobileConfig?.LocationConfiguration
        );
        const location: LocationData = setDefaultLocation || data.locations[0];
        await this.domainSvc.saveDomainInfo(data, location._id, '');
      }
    }
  }

  async getStringKeyValue(key: string): Promise<string> {
    const config = await ManagedConfigurations.getString({ key });
    const value = config.value;
    // const value = config.value || '';
    return value;
  }

  async getBooleanKeyValue(key: string): Promise<boolean> {
    // const defaultValue = key === CONFIG.LOCK_LOCATION_CHANGE ? false : true;
    const config = await ManagedConfigurations.getBoolean({ key });
    const value = config.value;
    // const value = config.value || defaultValue;
    return value;
  }

  async getNumberKeyValue(key: string): Promise<number> {
    const config = await ManagedConfigurations.getNumber({ key });
    const value = config.value;
    // const value = config.value || 0;
    return value;
  }

  async handleDomainDetail(intuneConfig: MobileConfiguration) {
    const data = await this.domainSvc.domainDetails(intuneConfig.Domain);

    if (data?.authProviders?.length) {
      const azureAD = AuthProvidersTypes.azureAD.toLowerCase();
      const index = data.authProviders.findIndex(
        (provider) => provider.AuthProvider.toLowerCase() === azureAD
      );
      const authAccounts = this.loginAccountService.authenticatedAccount$.value;
      const authAccountAvail = authAccounts.some(
        (account) => (account?.authProvider || '').toLowerCase() === azureAD
      );
      if (index > -1 && !authAccountAvail) {
        this.azureLogin(data.authProviders[index]);
        this.addListnerForDeeplinks(index, data.authProviders);
      }
    }
    return data;
  }

  azureLogin(authProviders: AuthProviders) {
    const provider = authProviders.AuthProvider.toLowerCase();
    const browserType = Capacitor.isNativePlatform() ? '_system' : '_self';
    const authId = authProviders._id;
    this.inAppBrowser.create(
      SOCIAL_URL.azureLogin(authId, authProviders.OrgID, provider),
      browserType,
      {}
    );
  }

  addListnerForDeeplinks(index: number, authProviders: AuthProviders[]) {
    this.appUrlOpenListner = App.addListener('appUrlOpen', async (data) => {
      if (data.url.indexOf(AuthProvidersTypes.azureAD.toLowerCase()) > -1) {
        let hashId = data.url.split('hashId=').pop();
        if (Capacitor.getPlatform() == 'ios') {
          hashId = hashId.slice(0, -1);
        }
        this.handleHashId(index, authProviders, hashId);
      } else {
        this.toastService.presentErrorToast();
      }
    });
  }

  async handleHashId(index: number, authProviders: AuthProviders[], hashId: string) {
    try {
      this.loadingService.present('LOADING');
      if (hashId !== 'NA') {
        const authProvider = authProviders[index];
        const apiResult = await this.loginAccountService.ssoConfirm(hashId, authProvider._id);
        const userName = apiResult?.data?.user?.Username || '';

        const accountsData = {
          customerName: this.sharedSvc?.getCustomerDetails?.customerData?.CustomerName || '',
          account: userName,
          description: userName,
          default: true,
          providerIndex: index,
          providerName: authProvider.ProviderName,
          ssoConfirmationResp: apiResult.data,
          authProvider: authProvider.AuthProvider,
          auto: true,
        };
        this.loginAccountService.autoAccountAvail$.next(true);
        await this.loginAccountService.create(accountsData);

        if (this.appUrlOpenListner) {
          await this.appUrlOpenListner.remove();
        }
        await this.setAccountOnlyFlag();
      }
    } catch (error) {
      this.toastService.presentErrorToast();
    } finally {
      this.loadingService.dismiss();
    }
  }

  async setAccountOnlyFlag() {
    const accountOnlyEle: any = document.getElementById('accountOnly');
    if (accountOnlyEle) {
      accountOnlyEle.checked = true;
      accountOnlyEle.disabled = true;
    }
    this.sharedSvc.showAccountOnlySection = true;
    await this.loginAccountService.setAccountOnly(true);
  }

  private setIntuneConfigData(mdmProfile: any): MobileConfiguration {
    const mobileConfig = {};
    if (mdmProfile?.Domain) {
      mobileConfig['Domain'] = mdmProfile.Domain;
    }
    if (mdmProfile?.CloudStorage) {
      mobileConfig['CloudStorage'] = mdmProfile.CloudStorage.toLowerCase() === 'true';
    }
    if (mdmProfile?.EmailOption) {
      mobileConfig['EmailOption'] = mdmProfile.EmailOption.toLowerCase() === 'true';
    }
    if (mdmProfile?.FileOption) {
      mobileConfig['FileOption'] = mdmProfile.FileOption.toLowerCase() === 'true';
    }
    if (mdmProfile?.LockLocationChange) {
      mobileConfig['LockLocationChange'] = mdmProfile.LockLocationChange.toLowerCase() === 'true';
    }
    if (mdmProfile?.PictureOption) {
      mobileConfig['PictureOption'] = mdmProfile.PictureOption.toLowerCase() === 'true';
    }
    if (mdmProfile?.QRScanning) {
      mobileConfig['QRScanning'] = mdmProfile.QRScanning.toLowerCase() === 'true';
    }
    return mobileConfig;

    // return {
    //   CloudStorage: mdmProfile.CloudStorage.toLowerCase() === "true",
    //   Domain: mdmProfile.Domain,
    //   EmailOption: mdmProfile.EmailOption.toLowerCase() === "true",
    //   FileOption: mdmProfile.FileOption.toLowerCase() === "true",
    //   LockLocationChange:
    //     mdmProfile.LockLocationChange.toLowerCase() === "true",
    //   PictureOption: mdmProfile.PictureOption.toLowerCase() === "true",
    //   QRScanning: mdmProfile.QRScanning.toLowerCase() === "true",
    // };
  }
}
